// extracted by mini-css-extract-plugin
export var productImage = "_og-1";
export var viewLink = "_og-2";
export var wishlistItem = "_og-0";